// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div {
  text-align: center;
}

.card-title {
  font-size: 16px;
  font-weight: bold;
  white-space: pre;
  text-transform: capitalize;
}

.card-number {
  font-size: 14px;
  white-space: nowrap;
}

.mat-card {
  margin: 15px 0 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/card/card.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;;AAEA;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;AACJ;;AAEA;EACI,eAAA;EACA,mBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ","sourcesContent":["div {\n    text-align: center;\n}\n\n.card-title {\n    font-size: 16px;\n    font-weight: bold;\n    white-space: pre;\n    text-transform: capitalize;\n}\n\n.card-number {\n    font-size: 14px;\n    white-space: nowrap;\n}\n\n.mat-card {\n    margin: 15px 0 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
